const GET_COMMISSION_PROFILE = 'GET_COMMISSION_PROFILE';
const GET_COMMISSION_PROFILE_SUCCESS = 'GET_COMMISSION_PROFILE_SUCCESS';
const GET_COMMISSION_PROFILE_FAIL = 'GET_COMMISSION_PROFILE_FAIL';

const getCommissionProfile = () => {
	return {
		type: GET_COMMISSION_PROFILE,
	};
};
const getCommissionProfileSuccess = (response) => {
	return {
		type: GET_COMMISSION_PROFILE_SUCCESS,
		response,
	};
};
const getCommissionProfileFail = () => {
	return {
		type: GET_COMMISSION_PROFILE_FAIL,
	};
};

export default {
	types: {
		GET_COMMISSION_PROFILE,
		GET_COMMISSION_PROFILE_SUCCESS,
		GET_COMMISSION_PROFILE_FAIL,
	},
	creators: {
		getCommissionProfile,
		getCommissionProfileSuccess,
		getCommissionProfileFail,
	},
};
